// extracted by mini-css-extract-plugin
module.exports = {"inductee-induction-hero":"InducteeInductionHero_inductee-induction-hero__A54li"};